import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

export interface BrandingBarStyles {
    container: InjectableCss;
    redAccent: InjectableCss;
    silverAccent: InjectableCss;
}

const brandingBarStyles: BrandingBarStyles = {
    container: {
        css: css`
            width: 100%;
            background-color: #191919;
            height: 35px;
            display: flex;
        `,
    },
    redAccent: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 15%;
                        `,
                        css`
                            width: 15%;
                        `,
                        css`
                            width: 15%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            background-color: #CD2037;
            display: flex;
            width: 7%;
            height: 100%;
            transform: skewX(50deg);
            -ms-transform: skewX(50deg);
            -webkit-transform: skewX(50deg);
        `,
    },
    silverAccent: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 15%;
                        `,
                        css`
                            width: 15%;
                        `,
                        css`
                            width: 15%;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            background-color: #676b6e;
            display: flex;
            width: 7%;
            height: 100%;
            transform: skewX(50deg);
            -ms-transform: skewX(50deg);
            -webkit-transform: skewX(50deg);
            position: relative;
            left: -1px;
        `,
    },
};

type Props = OwnProps;

const InformationBar: React.FC<Props> = () => {
    return (
        <StyledWrapper {...brandingBarStyles.container}>
            <StyledWrapper {...brandingBarStyles.redAccent} className="accent-background"></StyledWrapper>
            <StyledWrapper {...brandingBarStyles.silverAccent}></StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: InformationBar,
    definition: {
        group: "Common",
        icon: "Row",
        fieldDefinitions: [],
    },
};

export default widgetModule;
